import { notify as publicNotify } from './ping-notifications-v1-public-notification-notifications.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const notify: MaybeContext<
  BuildRESTFunction<typeof publicNotify> & typeof publicNotify
> = /*#__PURE__*/ createRESTModule(publicNotify);

export {
  Role,
  Channel,
  DashboardPages,
} from './ping-notifications-v1-public-notification-notifications.universal.js';
export {
  Public_notification,
  PublicNotifyRequest,
  PublicNotifyRequestRecipientsFilterOneOf,
  PublicNotifyRequestActionTargetOneOf,
  ToSiteContributors,
  ToContacts,
  ToTopicsSubscribers,
  Empty,
  NotifyOptions,
  NotifyOptionsRecipientsFilterOneOf,
  NotifyOptionsActionTargetOneOf,
} from './ping-notifications-v1-public-notification-notifications.universal.js';
export {
  RoleWithLiterals,
  ChannelWithLiterals,
  DashboardPagesWithLiterals,
} from './ping-notifications-v1-public-notification-notifications.universal.js';
